import { useState } from 'react';
import { useSubmission } from '../../../../../shared/hooks/use-submission';
import { useToast } from '../../../../../shared/hooks/use-toast';
import { apiErrorMessage } from '../../../../../shared/policies/api-error-message';
import { useRefreshCurrentUser } from '../../../hooks/use-refresh-current-user';
import { updateProfileName } from '../profile.api';

/** The Name row's inline edit. A name is not a way in, so it needs no confirmation. */
export function useNameEdit() {
  const [isEditing, setIsEditing] = useState(false);
  const { error, submitting, submit, clearError } = useSubmission();
  const refreshUser = useRefreshCurrentUser();
  const toast = useToast();

  async function save(name: string) {
    const isSaved = await submit(
      () => updateProfileName(name.trim()).then(() => true),
      (err) => apiErrorMessage(err) ?? "Couldn't save your name. Try again.",
    );
    if (!isSaved) return;
    await refreshUser();
    setIsEditing(false);
    toast.success('Name updated');
  }

  function cancel() {
    setIsEditing(false);
    clearError();
  }

  return { isEditing, error, submitting, edit: () => setIsEditing(true), save, cancel };
}
